import { Outlet } from 'react-router';

import { CustomersSearch } from './components/CustomersSearch/CustomersSearch';
import { CustomersTabBar } from './components/CustomersTabBar/CustomersTabBar';
import { useSellerHasCustomers } from './hooks/useSellerHasCustomers';
import { SellerInnerPageTemplate } from '../../routing/templates';

export const CustomersV2Layout = () => {
  // Shares the tab body's query key, so this costs no extra request.
  const { hasNoCustomers, loading } = useSellerHasCustomers();

  return (
    <SellerInnerPageTemplate
      additionalContent={
        <div className="mb-xl mt-xl flex w-full items-center justify-between gap-xl m:mb-l m:flex-col m:items-stretch m:gap-l">
          <h1 className="m-0 text-4xl leading-[52px]">Customers</h1>
          {/* Withheld until the count lands: rendering it first and pulling it
              back flashes a full-width input out of the header. */}
          {loading || hasNoCustomers ? null : <CustomersSearch />}
        </div>
      }
    >
      <div className="flex flex-col gap-xl">
        <CustomersTabBar />
        <Outlet />
      </div>
    </SellerInnerPageTemplate>
  );
};
